(() => {
class LuxuryDrawer extends HTMLElement {
  connectedCallback() {
    this.openButton = this.querySelector('[data-drawer-open]');
    this.shell = this.querySelector('.luxury-drawer__shell');
    this.dialog = this.querySelector('[data-drawer-dialog]');
    this.panels = [...this.querySelectorAll('[data-panel]')];
    this.initialPanelId = this.dataset.initialPanel || this.panels[0]?.id;
    this.rootPanel = this.panels.find((panel) => !panel.dataset.parent);
    this.showMedia = this.dataset.showMedia === 'true';
    this.backButton = this.querySelector('[data-drawer-back]');
    this.media = this.querySelector('[data-drawer-media]');
    this.crumb = this.querySelector('[data-drawer-crumb]');
    this.defaultTitle = this.crumb.textContent;
    this.lastFocused = null;
    this.openButton.addEventListener('click', () => this.open());
    this.querySelectorAll('[data-drawer-close]').forEach((button) => button.addEventListener('click', () => this.close()));
    this.querySelectorAll('[data-open-panel]').forEach((button) => button.addEventListener('click', () => this.showPanel(button.dataset.openPanel, button)));
    this.backButton.addEventListener('click', () => this.back());
    this.shell.addEventListener('keydown', (event) => this.onKeydown(event));
  }
  open() {
    clearTimeout(this.closeTimer);
    this.lastFocused = document.activeElement;
    this.shell.hidden = false;
    this.shell.setAttribute('aria-hidden', 'false');
    this.openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('luxury-drawer-lock');
    // Do not defer this state change with requestAnimationFrame: Shopify's preview
    // iframe can throttle that callback, leaving the drawer permanently transparent.
    void this.shell.offsetWidth;
    this.classList.add('is-open');
    document.body.classList.add('menu-open');
    // document.querySelectorAll('.hero-video video').forEach(v => v.pause());

    this.showPanel(this.initialPanelId);
    setTimeout(() => this.focusFirst(), 30);
  }
  close() {
    if (this.shell.hidden) return;
    this.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    // document.querySelectorAll('.hero-video video').forEach(v => v.play());
    this.openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('luxury-drawer-lock');
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => { this.shell.hidden = true; this.shell.setAttribute('aria-hidden', 'true'); this.lastFocused?.focus(); }, 360);
  }
  showPanel(panelId, opener) {
    const panel = this.querySelector('#' + CSS.escape(panelId));
    if (!panel) return;
    const isRootMenu = panel === this.rootPanel;
    const isFirstSubmenu = !isRootMenu && panel.dataset.parent === this.rootPanel?.id;
    const previousPanel = this.activePanel;
    const goingBack = previousPanel && panel.id === previousPanel.dataset.parent;
    if (previousPanel && previousPanel !== panel && previousPanel !== this.rootPanel) {
      previousPanel.classList.remove('is-active');
      previousPanel.classList.add('is-leaving');
      previousPanel.classList.toggle('is-returning', goingBack);
      clearTimeout(this.panelTimer);
      this.panelTimer = setTimeout(() => {
        if (previousPanel !== this.activePanel) previousPanel.hidden = true;
        previousPanel.classList.remove('is-leaving', 'is-returning');
      }, 280);
    }
    this.panels
      .filter((item) => item !== panel && item !== this.rootPanel && item !== previousPanel)
      .forEach((item) => { item.hidden = true; item.classList.remove('is-active', 'is-leaving', 'is-returning'); });

    if (!isRootMenu) {
      this.rootPanel.hidden = false;
      this.rootPanel.classList.add('is-active');
    }
    panel.hidden = false;
    panel.classList.remove('is-leaving', 'is-returning');
    requestAnimationFrame(() => panel.classList.add('is-active'));
    this.activePanel = panel;
    this.activeOpener = opener || null;
    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    this.classList.toggle('is-root-menu', isRootMenu);
    this.classList.toggle('has-side-submenu', !isRootMenu);
    this.classList.toggle('is-deep-menu', !isRootMenu && !isFirstSubmenu);
    this.classList.toggle('is-mobile-navigation', isMobile);
    this.media?.setAttribute('aria-hidden', String(isRootMenu || !this.showMedia));
    this.crumb.textContent = panel.dataset.title || this.defaultTitle;
    this.backButton.hidden = isRootMenu || (!isMobile && isFirstSubmenu);
    this.setImages(isRootMenu || !this.showMedia ? null : panel.dataset.imageKey);
    if (opener) setTimeout(() => this.focusFirst(), 230);
  }
  back() {
    const parentId = this.activePanel?.dataset.parent;
    if (!parentId) return;
    const trigger = this.querySelector('[data-open-panel="' + CSS.escape(this.activePanel.id) + '"]');
    this.showPanel(parentId);
    setTimeout(() => trigger?.focus(), 0);
  }
  setImages(key) {
    this.querySelectorAll('[data-menu-image-for]').forEach((card) => card.classList.toggle('is-active', key !== null && card.dataset.menuImageFor === key));
  }
  focusFirst() { (this.activePanel?.querySelector('a, button') || this.querySelector('[data-drawer-close]'))?.focus(); }
  onKeydown(event) {
    if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...this.dialog.querySelectorAll('a[href], button:not([hidden]):not([disabled])')].filter((item) => item.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
}
if (!customElements.get('luxury-drawer')) customElements.define('luxury-drawer', LuxuryDrawer);
})();
